import {Component, AfterViewInit, OnDestroy} from '@angular/core'
import {Router} from '@angular/router'

import {appStateProvider} from '../../insa-providers'
import {GenericChartsModule} from '../../insa-custom-scripts'
import {appConfig} from '../../../insaweb.config'
import {InsaService,LocalizeService} from '../../insa-services'
import {ChartModel, KendoColumnListDefinition} from '../../insa-models'

@Component({
    selector: "insaweb-donutCharts",
    templateUrl: 'donut-chart.component.html'
})
export class DonutChartsComponent implements OnDestroy, AfterViewInit {
    private assetCategorySubscription
    private currAnalysisSubscription;
    private selectedCurrency: string;

    constructor(private _insaService: InsaService, private _appStateProvider: appStateProvider, private _router:Router, private _localize: LocalizeService) {
       this.assetCategorySubscription = this._insaService.AssetCategoryChartEvent.subscribe(assetCategory => this.refreshDonutChart(assetCategory, "#AssetCategory","#AssetCategoryList",  this._localize.getLocalizedResource('Res3301').toUpperCase()));
       this.currAnalysisSubscription = this._insaService.CurrencyAnalysisChartEvent.subscribe(currAnalysis => this.refreshDonutChart(currAnalysis, "#CurrencyAnalysis", "#CurrAnalysisList",this._localize.getLocalizedResource('Res1052').toUpperCase()));  
     }
     
  
       private refreshDonutChart(charData: ChartModel[], chartSelector: string, listSelector: string, chartName: string){
        if (charData !== null && charData !== undefined && charData.length > 0) {
          let carouselOpt: CarouselOptions = {};
          carouselOpt.interval = appConfig.setCarouselTimeout;
          this.selectedCurrency = this._appStateProvider.selectedCurrency.text;
          let description = charData.sort((a, b) => Number(b.Value) - Number(a.Value));
          GenericChartsModule.KendoInitGenericDonutChart(chartSelector, description, "donut", "Value", "Description", chartName, this.legendVisible(), $("#genericDonutCarousel").width(), $("#genericDonutCarousel").height()-$(".message").height(), this.selectedCurrency);
          GenericChartsModule.KendoGenericChartList(listSelector, description, this.createDonutChartList());
          $('#genericDonutCarousel').carousel(carouselOpt);
        } else {
           this.selectedCurrency = "";
           GenericChartsModule.KendoInitGenericDonutChart(chartSelector, [], "donut", "Value", "Description", chartName, true, $("#genericDonutCarousel").width(), $("#genericDonutCarousel").height()-$(".message").height(), this.selectedCurrency);
           GenericChartsModule.KendoGenericChartList(listSelector,[], []);
        }
      }
   
 private chartDisplayedProperties(){
  if(this._router.url==="/home"){
    return true;
  }else if(this._router.url==="/chart"){
    return false;
  }
 }  

 private legendVisible(){
  if(this._router.url==="/home"){
    return false;
  }else if(this._router.url==="/chart"){
    return true;
  }
 }

 private onResize(event) {
   let assetCategoryChart: kendo.dataviz.ui.Chart = $("#AssetCategory").data("kendoChart");
   let currencyAnalysisChart: kendo.dataviz.ui.Chart = $("#CurrencyAnalysis").data("kendoChart");
   
   if (assetCategoryChart !== undefined && currencyAnalysisChart !== undefined) {
     assetCategoryChart.options.chartArea = {background: "", width: $('#genericDonutCarousel').width(), height: $('#genericDonutCarousel').height()-$(".message").height()}
     assetCategoryChart.redraw();

     currencyAnalysisChart.options.chartArea = {background: "", width: $('#genericDonutCarousel').width(), height: $('#genericDonutCarousel').height()-$(".message").height()}
     currencyAnalysisChart.redraw();
   }
 }

 private createDonutChartList() {
    let donutColumnDefs = new Array<KendoColumnListDefinition>();
    donutColumnDefs.push(new KendoColumnListDefinition("Description", '#: Description #'));
    donutColumnDefs.push(new KendoColumnListDefinition("Value", '#: kendo.toString(Value, "n2") #', { style: "text-align: right;" }));
    donutColumnDefs.push(new KendoColumnListDefinition("Percent", '#: kendo.toString(Percent*100, "0.00") + "%" #', { style: "text-align: right;" }));

    return donutColumnDefs;
} 

   ngAfterViewInit() {
      kendo.ui.progress($(".donutChart-loading"), this._appStateProvider.fetchingAssetCategory);
      kendo.ui.progress($(".donutChart-loading"), this._appStateProvider.fetchingCurrAnalysis);
      this.refreshDonutChart(this._insaService.chartDataCurrAnalysis, "#CurrencyAnalysis", "#CurrAnalysisList", this._localize.getLocalizedResource('Res1052').toUpperCase());
      this.refreshDonutChart(this._insaService.chartDataAssetCategory, "#AssetCategory","#AssetCategoryList", this._localize.getLocalizedResource('Res3301').toUpperCase());
   }
    
    ngOnDestroy(){
     this.currAnalysisSubscription.unsubscribe();
     this.assetCategorySubscription.unsubscribe(); 
    }
}




// WEBPACK FOOTER //
// ./app/insa-components/insa-charts/donut-chart.component.ts